<script setup lang="ts">
const acceptedPayments = [
  { logo: 'payment:mastercard', size: 'text-2xl', classes: '' },
  { logo: 'payment:visa', size: 'text-base', classes: 'text-visa dark:text-white' },
  { logo: 'payment:maestro', size: 'text-2xl', classes: '' },
  { logo: 'payment:amex-square', size: 'text-2xl', classes: 'text-amex' },
  { logo: 'payment:apple-pay', size: 'text-2xl', classes: '' },
  { logo: 'payment:google-pay', size: 'text-2xl', classes: '' },
]
</script>

<template>
  <div class="flex flex-wrap items-center">
    <Icon
      v-for="payment in acceptedPayments"
      :key="payment.logo"
      :name="payment.logo"
      :class="[payment.size, payment.classes]"
      class="mr4 mt2"
    />
  </div>
</template>
